import React from 'react'
import '../Section1/section1.css';
import '../../CategoryItems/ImgComponent/style/ImgComp.css'
import AllItem from '../../newArrival/AllItem';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay, Pagination } from 'swiper/modules'
import line1 from '../../../assets/icons/line1.avif'

const Section2Main = () => {
    let arr = [
      {
        "id": 19,
        "prdname": "Ruby Diamond Chain",
        "prdprice": 8999,
        "prdcategory": "Chain",
        "prddiscount": "disable",
        "prdimg":"[{\"url\":\"https://ik.imagekit.io/saufrbirqu/necklace19_1.jpg?updatedAt=1717073590404\",\"fileId\":\"66547eec37b244ef544ca1b2\",\"uploadedAt\":\"2024-05-27T12:39:09.317Z\"}]",
        "prdDetalis": "[{\"url\":\"https://ik.imagekit.io/saufrbirqu/3a_PAbIXpS81n.webp\",\"fileId\":\"665480ed37b244ef5452da79\",\"uploadedAt\":\"2024-05-27T12:47:42.333Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/3b_yRvqRElb0.webp\",\"fileId\":\"665480ed37b244ef5452da7d\",\"uploadedAt\":\"2024-05-27T12:47:42.438Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/3c_kAKEipO2Q.webp\",\"fileId\":\"665480ed37b244ef5452da5d\",\"uploadedAt\":\"2024-05-27T12:47:42.338Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/3d_mZDFXAHLUJ.webp\",\"fileId\":\"665480ed37b244ef5452da73\",\"uploadedAt\":\"2024-05-27T12:47:42.449Z\"}]",
        "discountlable": "2%off",
        "gender": "women",
        "jwelleryMaterial": "Silver",
        "diamondType": "Gem stone",
        "jwelleryColour": "Gold colour",
        "jwelleryCarats": "12ct",
        "weight": "220gm",
        "tax": 1,
        "desc": "Add a dash of glamour to your radiant personality with this stately pendant set crafted in 22 karat yellow gold",
        "createdAt": "2024-03-27T06:18:12.488Z",
        "updatedAt": "2024-05-27T12:48:06.383Z",
        "rating":5,
        "categoryId": 10
    },
    {
        "id": 12,
        "prdname": "Striking Gold Chain",
        "prdprice": 20000,
        "prdcategory": "Chain",
        "prddiscount": "disable",
        "prdimg":"[{\"url\":\"https://ik.imagekit.io/saufrbirqu/3b_QUM-Ws3H5.jpg\",\"fileId\":\"66547eec37b244ef544ca1b2\",\"uploadedAt\":\"2024-05-27T12:39:09.317Z\"}]",
        "prdDetalis": "[{\"url\":\"https://ik.imagekit.io/saufrbirqu/3b_QUM-Ws3H5.jpg\",\"fileId\":\"6654809037b244ef5452389c\",\"uploadedAt\":\"2024-05-27T12:46:09.691Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/3a_24NtX-ZT9.webp\",\"fileId\":\"6654809037b244ef5452388d\",\"uploadedAt\":\"2024-05-27T12:46:09.707Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/3c_rzVy6SFn7M.jpg\",\"fileId\":\"6654809037b244ef545238ae\",\"uploadedAt\":\"2024-05-27T12:46:09.722Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/3d_bCXUL5ieX.jpg\",\"fileId\":\"6654809037b244ef54523880\",\"uploadedAt\":\"2024-05-27T12:46:09.567Z\"}]",
        "discountlable": "5%off",
        "gender": "women",
        "jwelleryMaterial": "Silver",
        "diamondType": "Labgrown diamond",
        "jwelleryColour": "Rose gold",
        "jwelleryCarats": "12ct",
        "weight": "25gm",
        "tax": 1,
        "desc": "Beaded Chain Crafted in 22 Karat Yellow Gold",
        "createdAt": "2024-03-13T10:34:29.414Z",
        "updatedAt": "2024-05-27T12:46:10.626Z",
        "rating":5,
        "categoryId": 10
    },
    {
        "id": 11,
        "prdname": "Gold Small Plated  Handcrafted Embellished Choker",
        "prdprice": 29999,
        "prdcategory": "Necklace",
        "prddiscount": "disable",
        "prdimg":"[{\"url\":\"https://ik.imagekit.io/saufrbirqu/necklace11.jpg?updatedAt=1717072303792\",\"fileId\":\"66547eec37b244ef544ca1b2\",\"uploadedAt\":\"2024-05-27T12:39:09.317Z\"}]",
        "prdDetalis": "[{\"url\":\"https://ik.imagekit.io/saufrbirqu/necklace11.jpg?updatedAt=1717072303792\",\"fileId\":\"665485c537b244ef546122b8\",\"uploadedAt\":\"2024-05-27T13:08:22.056Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/necklace11_1.jpg?updatedAt=1717072303760\",\"fileId\":\"665485c537b244ef54612389\",\"uploadedAt\":\"2024-05-27T13:08:22.174Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/necklace11_2.jpg?updatedAt=1717072303972\",\"fileId\":\"665485c537b244ef54612389\",\"uploadedAt\":\"2024-05-27T13:08:22.174Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/necklace11_3.jpg?updatedAt=1717072304306\",\"fileId\":\"665485c537b244ef54612389\",\"uploadedAt\":\"2024-05-27T13:08:22.174Z\"}]",
        "discountlable": "5%off",
        "gender": "women",
        "jwelleryMaterial": "Gold",
        "diamondType": "Gem stone",
        "jwelleryColour": "Yellow",
        "jwelleryCarats": "14ct",
        "weight": "400gm",
        "tax": 1,
        "desc": null,
        "createdAt": "2024-03-13T10:33:34.028Z",
        "updatedAt": "2024-05-27T13:08:23.610Z",
        "rating":5,
        "categoryId": 9
    },
    {
        "id": 10,
        "prdname": "Sparkly Victorian Green Necklace ",
        "prdprice": 60000,
        "prdcategory": "Necklace",
        "prddiscount": "disable",
        "prdimg":"[{\"url\":\"https://ik.imagekit.io/saufrbirqu/neck10.jpg?updatedAt=1717071183698\",\"fileId\":\"66547eec37b244ef544ca1b2\",\"uploadedAt\":\"2024-05-27T12:39:09.317Z\"}]",
        "prdDetalis": "[{\"url\":\"https://ik.imagekit.io/saufrbirqu/3a_ap5Y5jxJh3.jpg\",\"fileId\":\"66547eec37b244ef544ca1b2\",\"uploadedAt\":\"2024-05-27T12:39:09.317Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/3b_gaDM1YgmD.jpg\",\"fileId\":\"66547eec37b244ef544ca297\",\"uploadedAt\":\"2024-05-27T12:39:09.693Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/3c_7PBxrV4Vm.jpg\",\"fileId\":\"66547eec37b244ef544ca1d5\",\"uploadedAt\":\"2024-05-27T12:39:09.370Z\"}]",
        "discountlable": "5% off",
        "gender": "women",
        "jwelleryMaterial": "Silver",
        "diamondType": "Gem stone",
        "jwelleryColour": "Rose gold",
        "jwelleryCarats": "14ct",
        "weight": "57gm",
        "tax": 1,
        "desc": "Long Necklaceset in 92.5 Gold Silver 57 gm",
        "createdAt": "2024-03-13T10:32:53.882Z",
        "updatedAt": "2024-05-27T12:39:10.860Z",
        "rating":5,
        "categoryId": 9
    },
    {
        "id": 9,
        "prdname": "Light Up - Diamond Small Nath Gold Design",
        "prdprice": 3000,
        "prdcategory": "Nose pin",
        "prddiscount": "disable",
        "prdimg":"[{\"url\":\"https://ik.imagekit.io/saufrbirqu/2b_IpjLJY-pj.jpg\",\"fileId\":\"66547eec37b244ef544ca1b2\",\"uploadedAt\":\"2024-05-27T12:39:09.317Z\"}]",
        "prdDetalis": "[{\"url\":\"https://ik.imagekit.io/saufrbirqu/2a_AAOjcd5hMr.jpg\",\"fileId\":\"66547dc837b244ef544a3286\",\"uploadedAt\":\"2024-05-27T12:34:17.289Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/2b_IpjLJY-pj.jpg\",\"fileId\":\"66547dc837b244ef544a3253\",\"uploadedAt\":\"2024-05-27T12:34:17.091Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/2c_2PdYYmtVg.jpg\",\"fileId\":\"66547dc837b244ef544a3272\",\"uploadedAt\":\"2024-05-27T12:34:17.089Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/2d_P67_SFCor0.jpg\",\"fileId\":\"66547dc837b244ef544a3289\",\"uploadedAt\":\"2024-05-27T12:34:17.235Z\"}]",
        "discountlable": "2% off",
        "gender": "women",
        "jwelleryMaterial": "Gold",
        "diamondType": "Natural diamond",
        "jwelleryColour": "Yellow",
        "jwelleryCarats": "18ct",
        "weight": "50gm",
        "tax": 1,
        "desc": "Light up your wedding outfit with a fancy intense 18k gold polish CZ diamond Nath Design.\n\nThe size of the nose ring is approx 1\" in diameter. This does not require the nose to be pierced.",
        "createdAt": "2024-03-13T10:31:54.676Z",
        "updatedAt": "2024-05-27T12:34:30.606Z",
        "rating":5,
        "categoryId": 8
    },
    {
        "id": 8,
        "prdname": "Delicate Radiant Pendant and Earrings Set",
        "prdprice": 30000,
        "prdcategory": "Pendant",
        "prddiscount": "disable",
        "prdimg":"[{\"url\":\"https://ik.imagekit.io/saufrbirqu/2a_7B6eBCUHHS.webp\",\"fileId\":\"66547e6f37b244ef544ba0a1\",\"uploadedAt\":\"2024-05-27T12:39:09.317Z\"}]",
        "prdDetalis": "[{\"url\":\"https://ik.imagekit.io/saufrbirqu/2a_7B6eBCUHHS.webp\",\"fileId\":\"66547e6f37b244ef544ba0a1\",\"uploadedAt\":\"2024-05-27T12:37:04.958Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/2b_wMaOWjP01y.webp\",\"fileId\":\"66547e7037b244ef544ba0c0\",\"uploadedAt\":\"2024-05-27T12:37:04.987Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/2c_8RKJ7J7Nm.webp\",\"fileId\":\"66547e6f37b244ef544ba084\",\"uploadedAt\":\"2024-05-27T12:37:04.932Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/2d_-Q0M65Upi.webp\",\"fileId\":\"66547e6f37b244ef544ba08e\",\"uploadedAt\":\"2024-05-27T12:37:04.879Z\"}]",
        "discountlable": "3% off",
        "gender": "women",
        "jwelleryMaterial": "Gold",
        "diamondType": "Gem stone",
        "jwelleryColour": "Gold colour",
        "jwelleryCarats": "20ct",
        "weight": "28gm",
        "tax": 1,
        "desc": "Add a dash of glamour to your radiant personality with this stately pendant and earrings set crafted in 20 karat yellow gold",
        "createdAt": "2024-03-13T10:31:04.946Z",
        "updatedAt": "2024-05-27T12:37:06.115Z",
        "rating":5,
        "categoryId": 7
    },
    {
        "id": 7,
        "prdname": "Moon Shape with Diamond Bangle ",
        "prdprice": 50000,
        "prdcategory": "Bangle",
        "prddiscount": "disable",
        "prdimg":"[{\"url\":\"https://ik.imagekit.io/saufrbirqu/2b_1qgNUyOluh.webp\",\"fileId\":\"66547c1237b244ef54435a41\",\"uploadedAt\":\"2024-05-27T12:39:09.317Z\"}]",
        "prdDetalis": "[{\"url\":\"https://ik.imagekit.io/saufrbirqu/2b_1qgNUyOluh.webp\",\"fileId\":\"66547c1237b244ef54435a41\",\"uploadedAt\":\"2024-05-27T12:26:59.339Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/2a_Z_ciX8Q-A.webp\",\"fileId\":\"66547c1237b244ef54435a0d\",\"uploadedAt\":\"2024-05-27T12:26:59.172Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/2c_ov6ozKPJYF.webp\",\"fileId\":\"66547c1237b244ef54435a5c\",\"uploadedAt\":\"2024-05-27T12:26:59.378Z\"}]",
        "discountlable": "5%off",
        "gender": "women",
        "jwelleryMaterial": "Gold",
        "diamondType": "Gem stone",
        "jwelleryColour": "Rose gold",
        "jwelleryCarats": "14ct",
        "weight": "440gm",
        "tax": 1,
        "desc": null,
        "createdAt": "2024-03-13T10:29:41.471Z",
        "updatedAt": "2024-05-27T12:27:00.480Z",
        "rating":5,
        "categoryId": 6
    },
    {
        "id": 6,
        "prdname": "Silver Diamond Earring",
        "prdprice": 35000,
        "prdcategory": "Earrings",
        "prddiscount": "disable",
        "prdimg":"[{\"url\":\"https://ik.imagekit.io/saufrbirqu/Earring3_TKM4UKgrnI.jpg\",\"fileId\":\"66547fb437b244ef544fbb82\",\"uploadedAt\":\"2024-05-27T12:39:09.317Z\"}]",
        "prdDetalis": "[{\"url\":\"https://ik.imagekit.io/saufrbirqu/Earring3_TKM4UKgrnI.jpg\",\"fileId\":\"66547fb437b244ef544fbb82\",\"uploadedAt\":\"2024-05-27T12:42:29.521Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/Earring3a_VWM7yoXVxL.jpg\",\"fileId\":\"66547fb437b244ef544fbb85\",\"uploadedAt\":\"2024-05-27T12:42:29.586Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/Earring3b_WHO8RWHWxO.jpg\",\"fileId\":\"66547fb437b244ef544fbb98\",\"uploadedAt\":\"2024-05-27T12:42:29.716Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/Earring3c_NkhzsrUYWI.jpg\",\"fileId\":\"66547fb437b244ef544fbb68\",\"uploadedAt\":\"2024-05-27T12:42:29.583Z\"}]",
        "discountlable": "2% off",
        "gender": "women",
        "jwelleryMaterial": "Silver",
        "diamondType": "Natural diamond",
        "jwelleryColour": "White",
        "jwelleryCarats": "18ct",
        "weight": "10gm",
        "tax": 1,
        "desc": null,
        "createdAt": "2024-03-13T10:28:46.824Z",
        "updatedAt": "2024-05-27T12:42:30.811Z",
        "rating":5,
        "categoryId": 5
    },
    {
        "id": 5,
        "prdname": "Small Nose Pin",
        "prdprice": 6999,
        "prdcategory": "Nose pin",
        "prddiscount": "disable",
        "prdimg":"[{\"url\":\"https://ik.imagekit.io/saufrbirqu/3a_pWef78_fKz.jpg\",\"fileId\":\"66547ff537b244ef5450bea0\",\"uploadedAt\":\"2024-05-27T12:39:09.317Z\"}]",
        "prdDetalis": "[{\"url\":\"https://ik.imagekit.io/saufrbirqu/3a_pWef78_fKz.jpg\",\"fileId\":\"66547ff537b244ef5450bea0\",\"uploadedAt\":\"2024-05-27T12:43:34.723Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/3b_qXFptx6XH.jpg\",\"fileId\":\"66547ff537b244ef5450bf79\",\"uploadedAt\":\"2024-05-27T12:43:34.779Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/3c_iG64Qq4h6.jpg\",\"fileId\":\"66547ff537b244ef5450be8c\",\"uploadedAt\":\"2024-05-27T12:43:34.730Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/3d_G4Pc81gVs.jpg\",\"fileId\":\"66547ff537b244ef5450bf41\",\"uploadedAt\":\"2024-05-27T12:43:34.753Z\"}]",
        "discountlable": "1% off",
        "gender": "women",
        "jwelleryMaterial": "Gold",
        "diamondType": "Labgrown diamond",
        "jwelleryColour": "Gold colour",
        "jwelleryCarats": "16ct",
        "weight": "120gm",
        "tax": 1,
        "desc": null,
        "createdAt": "2024-03-13T10:27:49.734Z",
        "updatedAt": "2024-05-27T12:43:35.824Z",
        "rating":5,
        "categoryId": 8
    },
    {
        "id": 4,
        "prdname": "Linked by Love  Yellow Gold Bracelet",
        "prdprice": 12000,
        "prdcategory": "Bracelet",
        "prddiscount": "disable",
        "prdimg":"[{\"url\":\"https://ik.imagekit.io/saufrbirqu/2b_ld5CTRTrab.webp\",\"fileId\":\"6655671337b244ef54fa27c5\",\"uploadedAt\":\"2024-05-27T12:39:09.317Z\"}]",
        "prdDetalis": "[{\"url\":\"https://ik.imagekit.io/saufrbirqu/2b_ld5CTRTrab.webp\",\"fileId\":\"6655671337b244ef54fa27c5\",\"uploadedAt\":\"2024-05-28T05:09:40.311Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/2c_7gMI4OiHCt.jpg\",\"fileId\":\"6655671337b244ef54fa28be\",\"uploadedAt\":\"2024-05-28T05:09:40.180Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/2a_1fP1CzRoG4.jpg\",\"fileId\":\"6655671337b244ef54fa29ae\",\"uploadedAt\":\"2024-05-28T05:09:40.304Z\"}]",
        "discountlable": "5% off",
        "gender": "women",
        "jwelleryMaterial": "Gold",
        "diamondType": "Natural diamond",
        "jwelleryColour": "Yellow",
        "jwelleryCarats": "18ct",
        "weight": "150gm",
        "tax": 1,
        "desc": "Feel the love with our Linked by Love  Yellow Gold Bracelet! This heart interconnected drop design brings elegance and charm to every outfit. Wear your affection!",
        "createdAt": "2024-03-13T10:26:48.345Z",
        "updatedAt": "2024-05-28T05:09:41.269Z",
        "rating":5,
        "categoryId": 4
    },
    {
        "id": 3,
        "prdname": "The Leoneil Bracelet",
        "prdprice": 50000,
        "prdcategory": "Bracelet",
        "prddiscount": "disable",
        "prdimg":"[{\"url\":\"https://ik.imagekit.io/saufrbirqu/3a_rK_ewpp5IJ.webp\",\"fileId\":\"66547eec37b244ef544ca1b2\",\"uploadedAt\":\"2024-05-27T12:39:09.317Z\"}]",
        "prdDetalis": "[{\"url\":\"https://ik.imagekit.io/saufrbirqu/3a_rK_ewpp5IJ.webp\",\"fileId\":\"6655680b37b244ef54fe5e0f\",\"uploadedAt\":\"2024-05-28T05:13:48.145Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/3b_pyV0LdXKzK.webp\",\"fileId\":\"6655680b37b244ef54fe5dd1\",\"uploadedAt\":\"2024-05-28T05:13:48.088Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/3c_rzLD3RDsGt.webp\",\"fileId\":\"6655680b37b244ef54fe5da8\",\"uploadedAt\":\"2024-05-28T05:13:47.976Z\"},{\"url\":\"https://ik.imagekit.io/saufrbirqu/3d_O5RbEZyAP-.webp\",\"fileId\":\"6655680b37b244ef54fe5de9\",\"uploadedAt\":\"2024-05-28T05:13:48.098Z\"}]",
        "discountlable": "5% off",
        "gender": "women",
        "jwelleryMaterial": "Rose Gold",
        "diamondType": "Labgrown diamond",
        "jwelleryColour": "Gold colour",
        "jwelleryCarats": "20ct",
        "weight": "4gm",
        "tax": 1,
        "desc": "Embrace the essence of modern refinement with the Leoneil Bracelet, where sleek design meets textured detailing for a stylish statement. This emblem of elegance is meticulously designed to add a touch of glamour to any ensemble",
        "createdAt": "2024-03-13T10:25:55.152Z",
        "updatedAt": "2024-05-28T05:13:49.109Z",
        "rating":5,
        "categoryId": 4
    }
    ];
    return (
        <div className='m-2'>
            <div className=" text-center text-xl uppercase font-mono mt-24 mb-10 relative ">
                <h1 >BEST SELLING PRODUCTS</h1>
                <div className='flex justify-center line'>
                    <img src={line1} alt="" height={50} width={300} style={{ objectFit: 'cover', }} className='line' />
                </div>
            </div>
            <div className=" gap-8 justify-center mx-8">
        <Swiper
          slidesPerView={1}
          spaceBetween={10}
          autoplay={{
            delay: 1500,
            disableOnInteraction: false,
          }}
          breakpoints={{

            405: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            500: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            650: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            710: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
            951: {
              slidesPerView: 4,
              spaceBetween: 10,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 10,
            },
            1290: {
              slidesPerView: 4,
              spaceBetween: 10,
            },
            1390: {
              slidesPerView: 5,
              spaceBetween: 10,
            },
            1490: {
              slidesPerView: 5,
              spaceBetween: 10,
            },
            1790: {
              slidesPerView: 5,
              spaceBetween: 10,
            },
            1920: {
              slidesPerView: 6,
              spaceBetween: 10,
            },
            3000: {
              slidesPerView: 6,
              spaceBetween: 10,
            },
          }}
          modules={[Pagination , Autoplay]}
          className='mySwiper'
        >
          {arr?.map((x, i) => {
            return (
              <SwiperSlide key={i}>
                <div style={{ width: '300px' }}>
                  <AllItem
                    item={x}
                    prdimg={x.prdimg}
                    prdname={x.prdname}
                    prdprice={x.prdprice}
                  />
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
           
        </div>
    )
}

export default Section2Main